import { useClassName } from '@/styles/Accordion';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';
import { AccordionContentComponent } from './Accordion.Content';
import { AccordionGroupComponent } from './Accordion.Group';
import { AccordionToggleComponent } from './Accordion.Toggle';

export type AccordionProps = ComponentProps<'div'>;

export const AccordionComponent: Component<AccordionProps> = ({ children, ...props }) => {
  const className = useClassName('', props);

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};

export const Accordion = Object.assign(AccordionComponent, {
  Toggle: AccordionToggleComponent,
  Group: AccordionGroupComponent,
  Content: AccordionContentComponent,
});
